import styled from 'styled-components';
import Card from 'react-bootstrap/Card';

const PlaceholderCard = styled(Card)`
  border: 1px solid #dee2e6;
  min-height: 220px;
  height: 100%;
  display: flex;
`;

const WordCardPlaceholder = () => {
  return (
    <PlaceholderCard>
      <Card.Body
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div style={{ fontSize: '0.95rem', color: '#666', textAlign: 'center' }}>
          Select a word to see its definition.
        </div>
      </Card.Body>
    </PlaceholderCard>
  );
};

export default WordCardPlaceholder;
